import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Dialog, DialogActions, DialogContent, DialogTitle, Button, Card, CardContent, OutlinedInput} from '@material-ui/core'
import {Box, Container, TextField, FormControl, Radio, FormControlLabel, FormLabel, RadioGroup} from '@material-ui/core'
import {Grid, Tab, Tabs, Checkbox} from '@material-ui/core'

import {IconButton} from '@material-ui/core';
import { Label, MoreVert } from '@material-ui/icons';


import DescriptionIcon from '@material-ui/icons/Description';
import { UPLOAD_MAX_FILE_SIZE } from '../../../api/ServerApi';
import { readTextFile } from '../../../../api/file';
import { decimalColorToHexColor, getBase64ID, hexColorToDecimalColor } from '../../../../api/helpers';
import { SelectUsersDialog } from '../SelectUsersDialog';
import { SketchPicker } from 'react-color';
import { TabPanel } from '../../../../components/TabPanel';
//import { SelectUserDialog } from '../SelectUserDialog';
import { SelectObjectDialog } from '../SelectObjectDialog';
import { getSpeedIn } from '../../../api/Settings';


class EditGeofenceDialog_ extends React.Component {

    constructor(props){
        super(props)

        console.log('EditGeofenceDialog');
        console.log(this.props)

        let geofence = this.props.geofence ? {...this.props.geofence} : this.getDefaults()
        
        console.log(geofence)

        this.state = {
            geofence: geofence?geofence:{},
            allUsers: !Boolean(geofence.SelectedUsers)?1:0,
            errors: {
                Name: false,
                Color: false,
                SpeedFrom: false,
                SpeedTo: false,
                DynGroup: false
            },
            changed: false,
            selectUsersDialog:{
                open: false,
                users: geofence.Users
            },
            selectDynGroupDialog:{
                open: false,
                groupID: null
            },
            colorPicker: {
                open: false,
                color: ''
            },
            tab: 0
        }

        this.fileRef = React.createRef();

        this.handleSendFileChange = this.handleSendFileChange.bind(this)
        this.openSelectUsersDialog = this.openSelectUsersDialog.bind(this)
        this.handleAction = this.handleAction.bind(this)
        this.radioUsersHandleChange = this.radioUsersHandleChange.bind(this)
        this.handleTabChange = this.handleTabChange.bind(this)
        this.handleInput = this.handleInput.bind(this)
        this.handleDynGroupDialogAction = this.handleDynGroupDialogAction.bind(this)
    }

    getDefaults(){
        let geofence = {
            //ID: getBase64ID(),
            Name: '',
            Color: '-65536',
            SelectedUsers: '',
            SelectedUserIds: '',
            SpeedFrom: 60,
            SpeedTo: 300,
            EntryActions: this.getMessageActionsDefaults(),
            LeaveActions: this.getMessageActionsDefaults(),
            SpeedActions: this.getMessageActionsDefaults()
        }

        return geofence
    }

    getMessageActionsDefaults(){
        return {
            AlertDispatcher: false,
            SendMessageToInitatior: false,
            SendMessage: false,
            MessageToInitatior:"",
            Message:"",
            MessageObjectId:"",
            MessageObjectName:"",
            MessageObjectType:0
        }
    }

    getUsers(geofence){
        let names = geofence.SelectedUsers ? geofence.SelectedUsers.split(', ') : []
        let ids = geofence.SelectedUserIds ? geofence.SelectedUserIds.split(', ') : []

        let users = names.map((item, index)=>{return({ID:ids[index], Name:item})});

        return users;
    }

    setUsers(){

    }

    handleClose(){

        this.props.onAction({type: 'GEOFENCE_DIALOG_CLOSE'})
        
    }
    
    handleSave(){
        if(this.validate()){
            let geofence = {...this.props.geofence, ...this.state.geofence}
            this.props.onAction({type: 'GEOFENCE_DIALOG_SAVE', geofence: geofence})
        }else{
            this.props.onAction({type:'ALERT_DIALOG', message: this.props.t('CheckFormForErrors')})
        }
    }

    validate(){

        let geofence = {...this.props.geofence, ...this.state.geofence}

        let check = true

        let errors = this.state.errors;

        if(!geofence.Name){
            errors.Name = this.props.t('NameMustBeSpecified')
            check = false
        }else{
            errors.Name = false
        }

        this.setState({errors: errors})

        return check
    }

    handleSendFileClick(){       
        const fileInput = this.fileRef.current
        if(fileInput){
            fileInput.click()
        }
    }

    handleSendFileChange(){
        const fileInput = this.fileRef.current
        if(fileInput){
            if(fileInput.files){
                const file = fileInput.files[0];
                if(file.size > UPLOAD_MAX_FILE_SIZE){
                    this.props.onAction({
                        type:'ALERT_DIALOG', 
                        message: 'Max file size exceeded: ' + UPLOAD_MAX_FILE_SIZE + ' bytes'
                    })
                    //alert('Max file size exceeded: ' + UPLOAD_MAX_FILE_SIZE)
                }else{
                    readTextFile(file, this.handleReadFile.bind(this))
                }
            }
        }
    }

    handleReadFile(content){
        let geofence = JSON.parse(content);
        geofence.ID = null
        this.setState({geofence: geofence})

        console.log('handleReadFile geofence')
        console.log(geofence)
    }

    openSelectUsersDialog(){
        let selectUsersDialog = this.state.selectUsersDialog

        selectUsersDialog.open = true
        selectUsersDialog.users = this.getUsers(this.state.geofence)

        this.setState({selectUsersDialog: selectUsersDialog})
    }

    getNetworks(){
        let networks = this.props.onAction({type:'GET_NETWORKS'})
        return networks
    }

    handleAction(action){
        switch(action.type){
            case 'GET_NETWORKS':{
                return this.getNetworks();
                break
            }

            case 'SELECT_USERS_DIALOG_CLOSE':{
                let selectUsersDialog = this.state.selectUsersDialog
                selectUsersDialog.open = false
                
                this.setState({selectUsersDialog: selectUsersDialog})
                break;
            }

            case 'SELECT_USERS_DIALOG_SELECT':{
                let geofence = {...this.state.geofence}
                //geofence.Users = action.users

                //console.log('SELECT_USERS_DIALOG_SELECT action.users')
                //console.log(action.users)

                geofence.SelectedUsers = action.users.map(item=>item.Name).join(', ')
                geofence.SelectedUserIds = action.users.map(item=>item.ID).join(', ')

                //alert("ids "+ geofence.SelectedUserIds)

                let allUsers = Boolean(geofence.SelectedUsers)?0:1;

                let selectUsersDialog = this.state.selectUsersDialog
                selectUsersDialog.open = false

                this.setState({selectUsersDialog: selectUsersDialog, geofence: geofence, allUsers: allUsers})
                break;
            }

            case 'SELECT_DYNGROUP_DIALOG_OPEN':{
                //alert('SELECT_DYNGROUP_DIALOG_OPEN')

                let selectDynGroupDialog = this.state.selectDynGroupDialog
                selectDynGroupDialog.open = true
                selectDynGroupDialog.groupID = this.state.geofence.DynGroupId
                this.setState({selectDynGroupDialog: selectDynGroupDialog})

                break
            }

            default:
                console.log('Undefined action case: '+action.type)
        }
        
    }

    handleDynGroupDialogAction(action){

        //alert('handleDynGroupDialogAction '+ action)

        switch(action.type){
            case 'SELECT_OBJECT_DIALOG_OPEN':{
                let selectDynGroupDialog = this.state.selectDynGroupDialog
                selectDynGroupDialog.open = true
                this.setState({selectDynGroupDialog: selectDynGroupDialog})
                break
            }

            case 'SELECT_OBJECT_DIALOG_SELECT':{
                let selectDynGroupDialog = this.state.selectDynGroupDialog
                selectDynGroupDialog.open = false

                //alert(action.object.name + ' ' + action.object.id + ' ' + action.object.GUID + ' ' + action.object.type)

                let geofence = {...this.state.geofence}

                const changed = geofence.DynGroupId!==action.object.GUID ? {changed: true} : {}

                geofence.DynGroup = action.object.name
                geofence.DynGroupId = action.object.GUID

                this.setState({geofence: geofence, ...changed})

                this.setState({
                    selectDynGroupDialog: selectDynGroupDialog,
                    geofence: geofence, 
                    ...changed
                })

                //, formData: formData, errors: errors
                break
            }

            case 'SELECT_OBJECT_DIALOG_CLOSE':{
            //case 'SELECT_USER_DIALOG_CLOSE':{
                let selectDynGroupDialog = this.state.selectDynGroupDialog
                selectDynGroupDialog.open = false
                this.setState({selectDynGroupDialog: selectDynGroupDialog})
                break
            }
        }

    }

    radioUsersHandleChange(event){
        let allUsers = Number(event.target.value)

        //alert('radioUsersHandleChange '+allUsers)

        let geofence = {...this.state.geofence}
        if(allUsers==1){
            geofence.SelectedUsers = ""
            geofence.SelectedUserIds = ""
        }

        this.setState({geofence: geofence, allUsers: allUsers})
    }

    handleTabChange(event, newValue){
        this.setState({tab: newValue})
    }

    handleInput(event){
        const changed = !this.state.changed ? {changed: true} : {}
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value 
        //console.log(event.target.name + ' val='+val)
        const geofence = {...this.state.geofence, [event.target.name]: val}
        this.setState({geofence: geofence, ...changed})
    }

    handleChangeEntryAction(messageActions){
        let geofence = {...this.state.geofence}
        geofence.EntryActions = messageActions

        //console.log('geofence.EntryActions')
        //console.log(geofence.EntryActions)

        this.setState({geofence: geofence})
    }

    handleChangeLeaveAction(messageActions){
        let geofence = {...this.state.geofence}
        geofence.LeaveActions = messageActions

        this.setState({geofence: geofence})
    }

    handleChangeSpeedAction(messageActions){
        let geofence = {...this.state.geofence}
        geofence.SpeedActions = messageActions

        this.setState({geofence: geofence})
    }
    
    render(){
        const {t} = this.props

        const title = t('Geofence')

        //const margin = {}//{margin: 0}

        const styles = {
            tab:{
                minWidth:80
            },
            tabPanel:{
                minHeight: 300
            }
        };

        const margin = {margin:'16px 0 8px 0'}

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">

    {this.state.selectUsersDialog.open? (
        <SelectUsersDialog open={this.state.selectUsersDialog.open}
            networks={this.getNetworks()}
            users={this.state.selectUsersDialog.users}
            networkID={this.props.networkID}
            onAction={this.handleAction} ></SelectUsersDialog>
    ) : null }
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent style={{minWidth:450}}>

        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>
            <Box textAlign="center">
                <TextField name="Name"  margin="normal"
                    style={{width: '100%'}}
                    label={this.state.errors.Name?this.state.errors.Name:t('Name')}
                    autoComplete="new-password"
                    error={this.state.errors.Name!==false}
                    value={this.state.geofence.Name}
                    onChange={this.handleInput}
                />
            </Box>

            <Box textAlign="">
                <FormControl style={{...margin, width: '100%'}}>
                    <TextField name="Name" margin="normal"
                        style={{backgroundColor: decimalColorToHexColor(this.state.geofence.Color),
                            cursor: 'pointer'}}
                        label={this.state.errors.Color?this.state.errors.Color:t('Color')}
                        readonly={true}
                        value={decimalColorToHexColor(this.state.geofence.Color)}
                        onClick={ ()=>{this.setState({colorPicker:{
                            open: true, color: decimalColorToHexColor(this.state.geofence.Color)
                        }} ) } } 
                    ></TextField>
                </FormControl>

{/*todo ColorPickerDialog component*/}
                <Dialog open={this.state.colorPicker.open}>
                    <DialogTitle id="edit-dialog-title">{t('SelectColor')}</DialogTitle>
                    <DialogContent>
                        <SketchPicker name="Color" 
                            color={this.state.colorPicker.color}
                            onChangeComplete={(color)=>{
                                this.setState({
                                    colorPicker:{open: true, color: color.hex}
                                } )
                            }}
                            ></SketchPicker>
                    </DialogContent>
                    <DialogActions>
                        <Button  variant="contained" color="primary"
                            onClick={()=>{
                                let color = hexColorToDecimalColor(this.state.colorPicker.color)
                                //alert('hexColorToDecimalColor' + this.state.colorPicker.color +' -> '+  color)
                                const geofence = {...this.state.geofence, Color: color}
                                this.setState({geofence: geofence, colorPicker:{open: false, color: ''}})
                            }}>
                            {t('Apply')}
                        </Button>
                        <Button variant="contained" color="inherit"
                                onClick={ ()=>{this.setState({colorPicker:{open: false, color: ''} }) } } 
                                >
                            {t('Cancel')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>

            <Card variant="outlined">
            <CardContent>
                <FormLabel component="legend">Users to Track</FormLabel>

                <Box>
                    <RadioGroup aria-label="allUsers" name="allUsers" 
                        value={this.state.allUsers} onChange={this.radioUsersHandleChange}>
                        <FormControlLabel value={1} control={<Radio />} label="All users" />
                        <FormControlLabel value={0} control={<Radio />} label="Selected User" />
                    </RadioGroup>
                </Box>
                <Box>      
                    <Grid container>
                        <Grid item xs={11} align="left">

                        <TextField
                            style={{width: '100%'}}
                            id="Members"
                            label={t('Members')}
                            multiline
                            variant="outlined"
                            rows={3}
                            InputProps={{readOnly: true}}
                            value={this.state.geofence.SelectedUsers}
                        />

                        </Grid>
                        <Grid item xs={1} style={{verticalAlign:'bottom', paddingTop:8}}>

                            <IconButton onClick={this.openSelectUsersDialog}><MoreVert /></IconButton>

                        </Grid>
                    </Grid>
                </Box>

            </CardContent>
            </Card>


            <Tabs  value={this.state.tab} 
                variant="scrollable"
                scrollButtons="auto"
                onChange={this.handleTabChange} aria-label="simple tabs example"
                indicatorColor="primary">
                <Tab wrapped style={styles.tab} label={t("Entry")} id="tab-0" aria-controls="tabpanel-0" />
                <Tab wrapped style={styles.tab} label={t("Leave")} id="tab-1" aria-controls="tabpanel-1" />
                <Tab wrapped style={styles.tab} label={t("Speed")} id="tab-2" aria-controls="tabpanel-2" />
            </Tabs>

            <TabPanel value={this.state.tab} index={0} style={styles.tabPanel}>

                <Box textAlign="" style={{...margin, width: '100%'}}>
                    
                    {this.state.selectDynGroupDialog.open? (
                        <SelectObjectDialog open={this.state.selectDynGroupDialog.open}
                            networkID={null} 
                            networks={this.getNetworks()}
                            types={[26]}
                            onAction={this.handleDynGroupDialogAction} ></SelectObjectDialog>
                    ) : null }


                    <Grid container>
                        <Grid item xs={5} > 

                        <label>
                            <Checkbox color="primary" 
                                checked={this.state.geofence.AddToDynGroup}
                                onChange={this.handleInput}
                                name="AddToDynGroup"
                            />
                            {t('AddToDynamicGroup')}
                            
                        </label>

                        </Grid>
                        <Grid item xs={5} align="left">
                            <TextField
                            name="DynGroup"
                            id="DynGroup"
                            onChange={()=>{this.handleAction({type: 'SELECT_DYNGROUP_DIALOG_OPEN'})}}
                            label={this.state.errors["DynGroup"]!==false? this.state.errors["DynGroup"] : t("DynamicGroup")}
                            value={this.state.geofence.DynGroup}
                            style={{width:'100%'}}
                            error={this.state.errors["DynGroup"]!==false}
                        />
                        </Grid>
                        <Grid item xs={2} style={{verticalAlign:'bottom', paddingTop:18}}>
                            <IconButton
                                size="small" color="inherit" aria-label="more edit" component="span"
                                onClick={()=>{this.handleAction({type: 'SELECT_DYNGROUP_DIALOG_OPEN'})}}>
                                <MoreVert />
                            </IconButton>
                        </Grid>
                    </Grid>


                </Box>
                <Box textAlign="" style={{...margin, width: '100%'}}>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.geofence.DeleteFromDynGroup}
                            onChange={this.handleInput}
                            name="DeleteFromDynGroup"
                        />
                        {t('DeleteFromDynamicGroupOnLeave')}
                    </label>
                </Box>

                <MessageActionPanel 
                    messageAction={this.state.geofence.EntryActions}
                    onAction={this.handleAction}
                    onChange={this.handleChangeEntryAction.bind(this)}
                />

            </TabPanel>


            <TabPanel value={this.state.tab} index={1} style={styles.tabPanel}>

                <MessageActionPanel 
                    messageAction={this.state.geofence.LeaveActions}
                    onAction={this.handleAction}
                    onChange={this.handleChangeLeaveAction.bind(this)}
                />

            </TabPanel>


            <TabPanel value={this.state.tab} index={2} style={styles.tabPanel}>

                <Box textAlign="" style={{...margin, width: '100%'}}>
                    <label>
                        Speed Range
                        <OutlinedInput  type="text" name="SpeedFrom"
                            id={"SpeedFrom-input"}
                            style={{width: 100, margin:'0 10px', padding:0}}
                            autoComplete="new-password"
                            value={this.state.geofence.SpeedFrom}
                            error={this.state.errors.SpeedFrom!==false}
                            onChange={this.handleInput}
                            aria-describedby={"SpeedFrom-helper-text"}
                        />
                            -
                        <OutlinedInput  type="text" name="SpeedTo"
                            id={"SpeedTo-input"}
                            style={{width: 100, margin:'0 10px', padding:0}}
                            autoComplete="new-password"
                            value={this.state.geofence.SpeedTo}
                            error={this.state.errors.SpeedTo!==false}
                            onChange={this.handleInput}
                            aria-describedby={"SpeedTo-helper-text"}
                        />

                        {getSpeedIn()}

                        {/*this.state.errors[name]!==false?
                        <span style={{color:'red', whiteSpace:'nowrap'}} id={name+"-helper-text"}>
                            {this.state.errors[name]}
                        </span>
                        :''*/}
                        
                    </label>
                </Box>



                <MessageActionPanel 
                    messageAction={this.state.geofence.SpeedActions}
                    onAction={this.handleAction}
                    onChange={this.handleChangeSpeedAction.bind(this)}
                />

            
            </TabPanel>

        </Container>
        </form>


        <Box>
        <input type="file" style={{display:'none'}} ref={this.fileRef} 
                            onChange={this.handleSendFileChange.bind(this)} />

        Import settings from .fnc
        <IconButton aria-label="more" title="Import settings from .fnc"
            onClick={this.handleSendFileClick.bind(this)}>
            <DescriptionIcon />
        </IconButton>
        </Box>


    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }

}


export const EditGeofenceDialog = withTranslation()(EditGeofenceDialog_);



class MessageActionPanel_ extends React.Component {

    constructor(props){
        super(props)

        console.log(this.props)

        this.state = {
            //messageAction: this.props.messageAction,
            errors:{
                MessageToInitatior: false,
                Message: false,
                MessageObjectName: false
            },
            selectObjectDialog:{
                open: false,
                userID: null
            },
        }

        this.handleInput = this.handleInput.bind(this)
        this.handleAction = this.handleAction.bind(this)

    }

    handleInput(event){
        const val =  event.target.type==='checkbox' ? event.target.checked : event.target.value 
        const messageAction = {...this.props.messageAction, [event.target.name]: val}
        this.props.onChange(messageAction)
    }

    getNetworks(){
        let networks = this.props.onAction({type:'GET_NETWORKS'})
        return networks
    }

    handleAction(action){

        //console.log('MessageActionPanel handleAction ' + action.type)
        //console.log(action) 

        switch(action.type){
            case 'SELECT_OBJECT_DIALOG_OPEN':{
            //case 'SELECT_USER_DIALOG_OPEN':{
                let selectObjectDialog = this.state.selectObjectDialog
                selectObjectDialog.open = true
                this.setState({selectObjectDialog: selectObjectDialog})
                break
            }

            case 'SELECT_OBJECT_DIALOG_SELECT':{
            //case 'SELECT_USER_DIALOG_SELECT':{
                let selectObjectDialog = this.state.selectObjectDialog
                selectObjectDialog.open = false

                let messageAction = {...this.props.messageAction}
                //let errors = {...this.errors}

                //console.log('action.object')
                //console.log(action.object)

                messageAction.MessageObjectName = action.object.name
                messageAction.MessageObjectId = action.object.id
                messageAction.MessageObjectType = action.object.type // 3//action.networkID

                //console.log(messageAction)

                this.props.onChange(messageAction);
                //errors.user = false
                this.setState({selectObjectDialog: selectObjectDialog})
                //, formData: formData, errors: errors
                break
            }

            case 'SELECT_OBJECT_DIALOG_CLOSE':{
            //case 'SELECT_USER_DIALOG_CLOSE':{
                let selectObjectDialog = this.state.selectObjectDialog
                selectObjectDialog.open = false
                this.setState({selectObjectDialog: selectObjectDialog})
                break
            }
        }
    }

    render(){

        const {t} = this.props

        const margin = {margin:'16px 0 8px 0'}

        return(

<>

<Box textAlign="" style={{...margin, width: '100%'}}>
    <label>
        <Checkbox color="primary" 
            checked={this.props.messageAction.AlertDispatcher}
            onChange={this.handleInput}
            name="AlertDispatcher"
        />
        {t('AlertDispatcher')}
    </label>
</Box>

<Box textAlign="" style={{...margin, width: '100%'}}>
    <label>
        <Checkbox color="primary" 
            checked={this.props.messageAction.SendMessageToInitatior}
            onChange={this.handleInput}
            name="SendMessageToInitatior"
        />
        {t('SendMessageToInitiator')}
    </label>
</Box>

<Box textAlign="center">
    <TextField name="MessageToInitatior"  margin="normal"
        style={{width: '100%'}}
        label={this.state.errors.MessageToInitatior?this.state.errors.MessageToInitatior:t('MessageToInitatior')}
        autoComplete="new-password"
        error={this.state.errors.MessageToInitatior!==false}
        value={this.props.messageAction.MessageToInitatior}
        onChange={this.handleInput}
    />
</Box>

<Box textAlign="" style={{...margin, width: '100%'}}>
    <label>
        <Checkbox color="primary" 
            checked={this.props.messageAction.SendMessage}
            onChange={this.handleInput}
            name="SendMessage"
        />
        {t('SendMessageTo')}
    </label>
</Box>

{this.state.selectObjectDialog.open? (
        <SelectObjectDialog open={this.state.selectObjectDialog.open}
            networkID={null} 
            networks={this.getNetworks()}
            onAction={this.handleAction} ></SelectObjectDialog>
    ) : null }

<Box textAlign="center">
    <Grid container>
        <Grid item xs={10} align="left">
            <TextField
            name="user"
            id="user"
            onChange={()=>{this.handleAction({type: 'SELECT_OBJECT_DIALOG_OPEN'})}}
            label={this.state.errors["MessageObjectName"]!==false? this.state.errors["MessageObjectName"] : t("Name")}
            value={this.props.messageAction.MessageObjectName}
            style={{width:'100%'}}
            error={this.state.errors["MessageObjectName"]!==false}
        />
        </Grid>
        <Grid item xs={2} style={{verticalAlign:'bottom', paddingTop:18}}>
            <IconButton
                size="small" color="inherit" aria-label="more edit" component="span"
                onClick={()=>{this.handleAction({type: 'SELECT_OBJECT_DIALOG_OPEN'})}}>
                <MoreVert />
            </IconButton>
        </Grid>
    </Grid>
</Box>

<Box textAlign="center">
    <TextField name="Message"  margin="normal"
        style={{width: '100%'}}
        label={this.state.errors.Message?this.state.errors.Message:t('Message')}
        autoComplete="new-password"
        error={this.state.errors.Message!==false}
        value={this.props.messageAction.Message}
        onChange={this.handleInput}
    />
</Box>

</>

        )


        {/*
"EntryActions": {
"AlertDispatcher":true,
"SendMessageToInitatior":true,
"SendMessage":true,
"MessageToInitatior":"You are in danger zone!",
"Message":"danger zone!",
"MessageObjectId":"8d5c2949-f097-4d3a-8f83-01c67abb1659",
"MessageObjectName":"admin",
"MessageObjectType":3},

*/}

    }
}

const MessageActionPanel = withTranslation()(MessageActionPanel_);